<template>
  <div class="r-login">
    <Modal footer-hide v-model="show" width="710">
      <div class="login common-flex">
        <img class="login-img" src="../assets/images/login-0114.jpg" alt="" />
        <div class="login-ipt">
          <div class="menu-item-line"></div>
          <div @click="show = false" class="iconfont iconguanbi common-hover"></div>
          <div class="title">{{ $t("login.title") }}</div>
          <div class="subtitle">{{ $t("login.welcome") }}</div>

          <div style="margin-bottom: 37px">
            <div class="lable-title">{{ $t("login.userName") }}</div>
            <div class="ipt-box">
              <Input v-model="params.username" class="ipt" type="text" />
            </div>
          </div>
          <div>
            <div class="lable-title">{{ $t("login.password") }}</div>
            <div class="ipt-box">
              <Input @keyup.enter.native="signIn" v-model="params.password" class="ipt" type="password" />
            </div>
          </div>
          <Checkbox style="margin-top: 16px" v-model="loginKeep">{{
            $t("login.remember")
          }}</Checkbox>
          <button class="login-btn" @click="signIn">
            {{ $t("login.login") }}
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      show: false,
      loginKeep: false,
      params: {
        username: "",
        password: "",
      },
    };
  },
  methods: {
    ...mapActions([
      "loginAction", //登录
      "getMemberAuthorityAction",//权限
    ]),
    //   点击登录
    signIn() {
      if (!this.params.username.trim()) {
        this.$Message.error(this.$t("login.userName") + this.$t("newOrder.cannotEmpty"));
        return;
      }
      if (!this.params.password.trim()) {
        this.$Message.error(this.$t("login.password") + this.$t("newOrder.cannotEmpty"));
        return;
      }
      
      sessionStorage.setItem("keepLogin", this.loginKeep);
      this.loginAction({
        username: this.params.username,
        password: this.params.password,
      })
        .then((res) => {
          console.log('login res:', res)
          if (res.code == 0) {
            this.show = false;
            this.$Message.success(res.message || this.$t("login.login") + "成功");
            
            // 清空表单
            this.params.username = "";
            this.params.password = "";
          } else {
            this.$Message.error(res.message || "登录失败");
          }
        })
        .catch((res) => {
          this.$Message.error(res.message || "登录失败，请检查网络连接");
        });
    },
  },
  watch: {
    //   sessionStorage.setItem("keepLogin", this.loginKeep);
    loginShow: {
      handler(newval, oldval) {
        this.show = newval;
      },
      immediate: true,
    },
    show: {
      handler(newval, oldval) {
        if (newval == false) {
          this.$emit("handLogin");
        }
      },
      immediate: true,
    },
  },
  props: {
    loginShow: Boolean,
  },
};
</script>
<style lang="less" scoped>
/deep/.ivu-input {
  border: none;
}
/deep/.ivu-icon-ios-close {
  display: none;
}
/deep/.ivu-modal-body {
  padding: 0;
}

.login {
  width: 710px;
  height: 455px;
  overflow: hidden;
  border-radius: 5px; /* 这里定义了圆角的半径 */
  .login-img {
    width: 340px;
    height: 457px;
    display: block;
  }
  .login-btn {
    width: 91px;
    height: 31px;
    line-height: 31px;
    background: #081938;
    font-size: 12px;
    font-family: Roboto, Roboto-Bold;
    font-weight: 700;
    text-align: left;
    color: #ffffff;
    line-height: 14px;
    margin: 46px 0 0 217px;
    text-align: center;
  }
  .login-ipt {
    width: 370px;
    height: 455px;
    position: relative;
    padding-left: 32px;
    .title {
      font-size: 28px;
      font-family: Times, Times-Bold;
      font-weight: 700;
      text-align: left;
      color: #081938;
      line-height: 34px;
      margin: 55px 0 0 0;
    }
    .lable-title {
      opacity: 0.4;
      font-size: 12px;
      font-family: Roboto;
      font-weight: 400;
      text-align: left;
      color: #081938;
      line-height: 14px;
    }
    .ipt-box {
      width: 306px;
      padding-bottom: 4px;
      border-bottom: 1px solid rgba(8, 25, 56, 0.3);
    }
    .ipt {
      border: none;
      outline: none;
      padding: 5px 0;
      width: 306px;
      margin-top: 10px;
      line-height: 16px;
    }
    .subtitle {
      opacity: 0.3;
      font-size: 11px;
      font-family: Times, Times-Roman;
      font-weight: Roman;
      text-align: left;
      color: #081938;
      line-height: 13px;
      margin-bottom: 40px;
    }
  }
  .iconguanbi {
    position: absolute;
    font-size: 12px;
    top: 15px;
    right: 15px;
    color: #999999;
    position: absolute;
  }
  .menu-item-line {
    position: absolute;
    top: 0;
    left: 32px;
    height: 8px;
    width: 53px;
    // right: 0;
    margin-left: auto;
    margin-right: auto;
    background: #0a4dcc;
  }
  .menu-item-line::after {
    width: 0;
    height: 0;
    border-bottom: 8px solid #fff;
    border-left: 8px solid transparent;
    content: "";
    z-index: 9;
    position: absolute;
    // width: 4px;
    // height: 4px;
    bottom: 0;
    right: 0;
    // background: #fff;
  }
  .menu-item-line::before {
    content: "";
    z-index: 9;
    position: absolute;
    width: 0;
    height: 0;
    border-bottom: 8px solid #fff;
    border-right: 8px solid transparent;
    left: 0;
    bottom: 0;
    // background: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/r-login.vue